// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27EbR","toggle":"styles_toggle__2ks6p","preview":"styles_preview__o2ZhV"};